module.exports = __webpack_public_path__ + "img/pos2-tit.6fe298ab.png";